// extracted by mini-css-extract-plugin
module.exports = {"button":"app-button_button__ltBwH","googleplay-on-ios":"app-button_googleplay-on-ios__6fd_B","appstore-on-android":"app-button_appstore-on-android__P_evJ"};